window.$ = window.jQuery = require('jquery');
var Utils = require('./utils');

var urls = Utils.getUrls();
var auth_token, currentUserId, currentEmail, confirmType, userIsConnected = false;
var app_server_url = urls.app_server_url;
var chat_signup_url = urls.chat_signup_url;
var expires = Utils.getCookieExpires();

var Auth = {
  signUpEmail: function() {
    var firstName, lastName;
    var utm = Utils.getUTMparams($('#utm-campaign'));
    var waitText = $('#signUpForm .wait-text');
    var signUpBtn = $('button.signUp.auth');
    var fullName = $('input#sfullName');
    var email = $('input#semail');
    var subscribe = $('input#subscribe');
    var subscribeCheck = subscribe.is(':checked');
    if(!subscribeCheck) {
      fullName.trigger('blur');
      email.trigger('blur');
      setTimeout(function() {
        window.alert("Please subscribe to Pet Parade's newsletters and offers in order to enter your pet. We NEVER share your email address with third parties without your consent. However we WILL show you ads from our partners. This is how we fund the gift cards you earn!");
        waitText.addClass('hidden');
        signUpBtn.removeClass('hidden');
        return false;
      }, 100);
    } else {
      waitText.removeClass('hidden');
      signUpBtn.addClass('hidden');
      if(fullName.val() === '' || email.val() === '') {
        window.alert('Woof woof! Please fill in all of the fields.');
        waitText.addClass('hidden');
        signUpBtn.removeClass('hidden');
        fullName.focus();
        return false;
      }
      var fullNameVal = fullName.val();
      if (fullNameVal.match(/\S+/g).length > 1)  {
        firstName = fullNameVal.substr(0,fullNameVal.indexOf(' '));
        lastName = fullNameVal.substr(fullNameVal.indexOf(' ')+1);
      } else {
        window.alert('Woof woof! Please enter your first and last name.');
        waitText.addClass('hidden');
        signUpBtn.removeClass('hidden');
        fullName.focus();
        return false;
      }

      var data = $('#signUpForm').serialize() + '&firstName=' + firstName + '&lastName=' + lastName + '&source=web';
      if (utm['utm_campaign'] != null && utm['utm_campaign'] != '') {
        data += '&utm_campaign=' + utm['utm_campaign'] + '&utm_medium=' + utm['utm_medium'] + '&utm_source=' + utm['utm_source'];
      }

      // Get referrer param
      var referrer = Utils.getParameterByName('referrer');
      if (referrer != null) data += '&referrer=' + referrer;

      $.post(app_server_url + '/v2/user/create', data, function()  {
        //console.log("SIGNUP EMAIL");
      }).done(function(response)  {
        currentEmail = response.email;
        confirmType = "signUp";
        $('#signUpModal').modal('hide');
        $('#signUpModal').on('hidden.bs.modal', function() {
          var maskedEmail = '**' + currentEmail.slice(2);
          $('.masked-email').text(maskedEmail);
          $('#emailCodeModal').modal({
            show: true,
            background: 'static',
            keyboard: false
          });
        });
      }).fail(function(response)  {
        if (response.responseText) alert(JSON.parse(response.responseText).err);
        waitText.addClass('hidden');
        signUpBtn.removeClass('hidden');
        fullName.focus();
      });
    }
  },
  signInEmail: function(optOut, type) {
    var isOptOut = !!optOut;
    if(isOptOut && !type) return false;
    var form = isOptOut ? $('#optOutLoginForm') : $('#loginForm');
    var waitText = isOptOut ? $('#optOutLoginForm .wait-text') : $('#loginForm .wait-text');
    var loginBtn = isOptOut ? $('button.auth.opt-out.logIn') : $('button.auth.logIn');
    var email = isOptOut ? $('#optOutLoginForm #oemail') : $('#loginForm #lemail');
    var modal = isOptOut ? $('#optOutLoginModal') : $('#loginModal');
    waitText.removeClass('hidden');
    loginBtn.addClass('hidden');
    if(email.val() === '') {
      window.alert('Woof woof! Please fill the email field.');
      waitText.addClass('hidden');
      loginBtn.removeClass('hidden');
      email.focus();
      return false;
    }
    $.ajax({
      url: app_server_url + '/v2/auth/login',
      type: 'POST',
      data: form.serialize(),
      dataType: 'json',
      success: function (response) {
        currentEmail = response.email;
        confirmType = isOptOut ? type : "signIn";
        modal.modal('hide');
        modal.on('hidden.bs.modal', function () {
          $('#emailCodeModal').modal({
            show: true,
            background: 'static',
            keyboard: false
          });
        });
      },
      error: function(response)  {
        if (response.responseText) alert(JSON.parse(response.responseText).err);
        waitText.addClass('hidden');
        loginBtn.removeClass('hidden');
        email.focus();
      }
    });
  },
  confirmEmailCode: function() {
    var utm = Utils.getUTMparams($('#utm-campaign'));
    var waitText = $('#emailCodeForm .wait-text');
    var verifyBtn = $('button.emailCodeBtn.auth');
    var code = $('input#emailCode');

    code.trigger('blur');
    waitText.removeClass('hidden');
    verifyBtn.addClass('hidden');

    if (code.val() === '') {
      window.alert('Woof woof! Please fill in all of the fields.');
      waitText.addClass('hidden');
      verifyBtn.removeClass('hidden');
      code.focus();
      return false;
    }

    var data = 'code=' + code.val() + '&email=' + currentEmail;

    $.post(app_server_url + '/v2/auth/confirmLoginCode', data, function()  {
      //console.log("SIGNUP EMAIL");
    }).done(function(response)  {
      if(confirmType === "signUp" || confirmType === "signIn") {
        if (response.user.state === 4) {
          auth_token = response.token;
          currentUserId = response.user.id;
          $('#emailCodeModal').modal('hide');
          $('#emailCodeModal').on('hidden.bs.modal', function () {
            $('#phoneNumberModal').modal({
              show: true,
              backdrop: 'static',
              keyboard: false
            });
          });
          $('#phoneNumberModal').on('shown.bs.modal', function () {
            $('#phoneNumber').focus();
            $('#phoneNumberModal .wait-text').addClass('hidden');
          });
        } else if (response.user.state === 5) {
          auth_token = response.token;
          currentUserId = response.user.id;
          $('#emailCodeModal').modal('hide');
          $('#emailCodeModal').on('hidden.bs.modal', function () {
            $('#emailVerifyModal').modal({
              show: true,
              backdrop: 'static',
              keyboard: false
            });
          });
          $('#emailVerifyModal').on('shown.bs.modal', function () {
            $('#emailVerify').focus();
            $('#emailVerifyModal .wait-text').addClass('hidden');
          });
        } else {
          document.cookie = 'token=' + response.token + ';domain=parade.pet;path=/' + expires;
          document.cookie = 'utm_campaign=' + utm['utm_campaign'] + ';domain=parade.pet;path=/' + expires;
          document.cookie = 'utm_medium=' + utm['utm_medium'] + ';domain=parade.pet;path=/' + expires;
          document.cookie = 'utm_source=' + utm['utm_source'] + ';domain=parade.pet;path=/' + expires;
          Utils.redirectUser(chat_signup_url);
        }
      } else {
        $('#emailCodeModal').modal('hide');
        var authToken = response.token;
        if(confirmType === 'email') {
          Auth.optOutEmail(authToken, true);
        }
        if(confirmType === 'sell') {
          Auth.optOutSell(authToken, true);
        }
      }
    }).fail(function(response) {
      if (response.responseText) alert(JSON.parse(response.responseText).err);
      waitText.addClass('hidden');
      verifyBtn.removeClass('hidden');
      code.focus();
    });
  },
  requestSmsCode: function() {
    var phoneNumber = $('#phoneNumber').val();
    var waitText = $('#phoneNumberModal .wait-text');
    var phoneModal = $('#phoneNumberModal');
    var codeModal = $('#codeModal');
    var codeInput = $('#smsCode');
    var codeWaitText = $('#codeModal .wait-text');
    var button = $('#phoneNumberModal button.phoneNumber');
    var targetUrl = app_server_url + '/user/sendMobileVerification';
    if(phoneNumber) {
      waitText.removeClass('hidden').html('Please Wait...');
      button.addClass('hidden');
      $.post(targetUrl, {
        userId: currentUserId,
        phoneNumber: phoneNumber
      }).done(function(response) {
        phoneModal.modal('hide');
        phoneModal.on('hidden.bs.modal', function() {
          codeModal.modal({
            show: true,
            backdrop: 'static',
            keyboard: false
          });
          waitText.addClass('hidden');
          button.removeClass('hidden');
          codeWaitText.addClass('hidden');
        });
        codeModal.on('shown.bs.modal', function() {
          codeInput.focus();
        });
      }).fail(function(err) {
        button.removeClass('hidden');
        waitText.html(err.responseText);
      });
    }
  },
  submitSmsCode: function() {
    var code = $('#smsCode').val();
    var targetUrl = app_server_url + '/user/verifyMobileCode';
    var waitText = $('#codeModal .wait-text');
    var button = $('#codeModal button.smsCode');
    if(code) {
      waitText.removeClass('hidden').html('Please Wait...');
      button.addClass('hidden');
      $.post(targetUrl, {
        userId: currentUserId,
        code: code
      }).done(function() {
        waitText.addClass('hidden');
        var utm = Utils.getUTMparams($('#utm-campaign'));
        document.cookie = 'token=' + auth_token + ';domain=parade.pet;path=/' + expires;
        document.cookie = 'utm_campaign=' + utm["utm_campaign"] + ';domain=parade.pet;path=/' + expires;
        document.cookie = 'utm_medium=' + utm["utm_medium"] + ';domain=parade.pet;path=/' + expires;
        document.cookie = 'utm_source=' + utm["utm_source"] + ';domain=parade.pet;path=/' + expires;
        Utils.redirectUser(chat_signup_url);
      }).fail(function(err) {
        waitText.html(err.responseText);
        button.removeClass('hidden');
        $('#smsCode').val('');
      });
    }
  },
  verifyEmail: function() {
    var code = $('#emailVerify').val();
    var targetUrl = app_server_url + '/user/verifyEmail';
    var waitText = $('#emailVerifyModal .wait-text');
    var button = $('#emailVerifyModal button.emailVerify');
    if(code) {
      waitText.removeClass('hidden').html('Please Wait...');
      button.addClass('hidden');
      $.post(targetUrl, {
        userId: currentUserId,
        code: code
      }).done(function() {
        waitText.addClass('hidden');
        var utm = Utils.getUTMparams($('#utm-campaign'));
        document.cookie = 'token=' + auth_token + ';domain=parade.pet;path=/' + expires;
        document.cookie = 'utm_campaign=' + utm["utm_campaign"] + ';domain=parade.pet;path=/' + expires;
        document.cookie = 'utm_medium=' + utm["utm_medium"] + ';domain=parade.pet;path=/' + expires;
        document.cookie = 'utm_source=' + utm["utm_source"] + ';domain=parade.pet;path=/' + expires;
        Utils.redirectUser(chat_signup_url);
      }).fail(function(err) {
        waitText.html(err.responseText);
        button.removeClass('hidden');
        $('#emailVerify').val('');
      });
    }
  },
  optOutEmail: function(token, isNeedLogin) {
    if(!token) return false;
    var targetUrl = app_server_url + '/v2/user/opt-out/email';
    $.ajax({
      url: targetUrl,
      type: "POST",
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).done(function() {
      $('.opt-out-result-title').html('Success');
      $('.opt-out-result-subtitle').html('You have been unsubscribed from all emails from Pet Parade.');
      if(!!isNeedLogin) {
        $('#optOutLoginModal').modal('hide');
        $('#optOutLoginModal').on('hidden.bs.modal', function() {
          $('#oemail').val('');
          $('#opassword').val('');
        });
        setTimeout(function() {
          $('#optOutResultModal').modal('show');
        }, 100);
      } else {
        $('#optOutResultModal').modal('show');
      }
    }).fail(function(err) {
      console.log('err', err);
      $('.opt-out-result-title').html('Failed');
      $('.opt-out-result-subtitle').html('You have been failed to unsubscribe from all emails from Pet Parade.');
      if(!!isNeedLogin) {
        $('#optOutLoginModal').modal('hide');
        $('#optOutLoginModal').on('hidden.bs.modal', function() {
          $('#oemail').val('');
          $('#opassword').val('');
        });
        setTimeout(function() {
          $('#optOutResultModal').modal('show');
        }, 100);
      } else {
        $('#optOutResultModal').modal('show');
      }
    });
  },
  optOutSell: function(token, isNeedLogin) {
    if(!token) return false;
    var targetUrl = app_server_url + '/v2/user/opt-out/sell';
    $.ajax({
      url: targetUrl,
      type: "POST",
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).done(function(res) {
      $('.opt-out-result-title').html('Success');
      $('.opt-out-result-subtitle').html('You have been opted out from selling your personal info.');
      if(!!isNeedLogin && res === "OK") {
        $('#optOutLoginModal').modal('hide');
        $('#optOutLoginModal').on('hidden.bs.modal', function() {
          $('#oemail').val('');
          $('#opassword').val('');
        });
        setTimeout(function() {
          $('#optOutResultModal').modal('show');
        }, 100);
      } else {
        $('#optOutResultModal').modal('show');
      }
    }).fail(function(err) {
      console.log('err', err);
      $('.opt-out-result-title').html('Failed');
      $('.opt-out-result-subtitle').html('You have been failed to opt out from selling your personal info.');
      if(!!isNeedLogin) {
        $('#optOutLoginModal').modal('hide');
        $('#optOutLoginModal').on('hidden.bs.modal', function() {
          $('#oemail').val('');
          $('#opassword').val('');
        });
        setTimeout(function() {
          $('#optOutResultModal').modal('show');
        }, 100);
      } else {
        $('#optOutResultModal').modal('show');
      }
    });
  }
};

module.exports = Auth;
